<div class="wrapper">
  <div class="content-wrapper">
    <div class="br-section-wrapper">

      <div class="form-group formWrapper">
        <div class="row searchWrapper">
          <input type="text" class="form-control height-27 marTopLeft3510" [(ngModel)]="loadDetailFilter.logon" style="width: 97px; margin-left:35px; margin-top: 35px;"
            placeholder="Logon" />

            <input type="text" class="form-control height-27 marTopLeft3510" [(ngModel)]="loadDetailFilter.scac" style="width: 97px; margin-left:15px; margin-top: 35px;"
            placeholder="scac" />

            <div class="form-group hidden datePickerOpen">
              <div class="input-group">
                <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
                  #datepicker="ngbDatepicker" [autoClose]="false"
                  (dateSelect)="onDateSelection($event); closeDatePicker && datepicker.toggle()" [displayMonths]="2"
                  [dayTemplate]="t" outsideDays="hidden" [startDate]="loadDetailFilter.fromDate">
                <ng-template #t let-date let-focused="focused">
                  <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                  </span>
                </ng-template>
              </div>
            </div>
            <div class="form-group height-27">
              <div class="input-group pointer marTopLeft3510" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                <label style="margin-top: 4px;">From : &nbsp;</label>
                <input disabled #dpFromDate class="form-control height-27" placeholder="dd-MM-yy"
                  style="width: 97px; color: black; cursor: pointer"
                  (click)="showOverlay = !showOverlay; datepicker.toggle()" name="dpFromDate"
                  [value]="formatDateForDisplay(loadDetailFilter.fromDate)"
                  (input)="loadDetailFilter.fromDate = validateInput(loadDetailFilter.fromDate, dpFromDate.value);">

                <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar height-27" type="button">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group ml-2 height-27">
              <div class="input-group pointer marTopLeft3510" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                <label style="margin-top: 4px;">To : &nbsp;</label>
                <input #dpToDate disabled class="form-control height-27 pointer" placeholder="yyyy-mm-dd"
                  style="width: 97px; color: black" name="dpToDate" [value]="formatDateForDisplay(loadDetailFilter.toDate)"
                  (change)="datepicker.toggle()" (input)="loadDetailFilter.toDate = validateInput(loadDetailFilter.toDate, dpToDate.value);">
                <!-- <div class="input-group-append">
                  <button class="btn btn-outline-secondary calendar height-27"
                    type="button" (click)="datepicker.toggle()">
                    <i class="fa fa-calendar" aria-hidden="true"></i>
                  </button>
                </div> -->
              </div>
            </div>
            <div class="form-group marTopLeft3510" style="margin-left: 25px;">
              <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                (click)="submitMethod()">Submit</button>
            </div>
          <!-- <span style="padding: 7px;
            margin-left: -3px;
            margin-top: 2%;
            height: 28px !important;
            border-radius: 3px;
            cursor: pointer;
            color: #fff;
            background-color: #7cacd7;" (click)="submitMethod()"> <i class="fa fa-search"
              aria-hidden="true"></i></span> -->
        </div>
       <div class="align-items-center marTop30 marLeft50">
          <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
            <nav class="" aria-label="Page navigation example text-center">
              <div class="text-center">
                <div class="pagination row marTop70">
                  <div class="page-item marLeft540 marTop17" (click)="nextBtnClick(-1)">
                    <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button" [class.disabled]="page<=1">
                      < </a>
                  </div>
                  <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                        <input type="text" (change)="submitMethod()" [(ngModel)]="page" class="w-25 borderRadius5 marTop2">
                        <br>
                      <b>Page</b>
                      </p>
                    </a></div>
                  <div class="page-item marLeftNot42 marTop17"><a class="page-link right-traverse borderRadius5 button" href="javascript:void(0)"
                      (click)="nextBtnClick(+1)"> >
                    </a></div>
                  <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                      <p style="margin-top: 0px;">
                       <input type="text" (change)="submitMethod()" class="w-25 borderRadius5 marTop2" [(ngModel)]="size">
                       <br>
                      <b>Size</b>
                      </p>
                    </a></div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>

      <div class="row"
      style="padding: 20px; margin-top: 30px;"
      *ngIf="!users || users.length == 0">
        <div class="col-12" >
          <i style="font-size: 12px;">** NOTE: Please input logon, scac, from date and to date and hit submit button to view load details  !</i>
        </div>
      </div>

      <div class="table-responsive marTop30" *ngIf="users.length > 0">
        <table id=" " class="table table-insurance-inner ">
          <thead class="header-user">
            <tr>
              <th class="wd-15p th-pd">Logon</th>
              <th class="wd-15p th-pd">Mobile Password</th>
              <th class="wd-15p th-pd">Route Id</th>
              <th class="wd-15p th-pd">BOL Id</th>
              <th class="wd-15p th-pd">Bill of lading</th>
              <th class="wd-15p th-pd">Product Id</th>
              <th class="wd-15p th-pd">Product Name</th>
              <th class="wd-15p th-pd">Terminal</th>
              <th class="wd-15p th-pd">Load Under</th>
              <th class="wd-15p th-pd">Quantity</th>
              <th class="wd-15p th-pd">Route Status</th>
              <th class="wd-15p th-pd">Scac</th>
              <!-- <th class="wd-15p th-pd">Tenant</th> -->
              <th class="wd-15p th-pd">Punch In</th>
              <th class="wd-15p th-pd">Punch Out</th>
              <th class="wd-15p th-pd">Date </th>
              <th class="wd-15p th-pd">Action</th>

            </tr>
          </thead>
          <tbody>
            <tr class="" *ngFor="let item of users">
              <td>{{item?.logon}}</td>
              <td>{{item?.mobilepassword}}</td>
              <td>{{item?.routeId}}</td>
              <td>{{item?.billOfLadingId}}</td>
              <td>{{item?.billOfLading}}</td>
              <td>{{item?.productId}}</td>
              <td>{{item?.productName}}</td>
              <td>{{item?.terminalName}}</td>
              <td>{{item?.loadUnderName}}</td>
              <td>{{item?.quantity}}</td>
              <td>{{item?.routeStatus}}</td>
              <td>{{item?.scac}}</td>
              <!-- <td>{{item?.tenant}}</td> -->
              <td>{{item?.punchIn}}</td>
              <td>{{item?.punchOut}}</td>
              <td>{{item?.date}}</td>
              <td><a href="javascript:void(0)"><i class="fa fa-pencil-square-o drug-ins-action" aria-hidden="true"
                data-toggle="modal" data-target="#addUserSelector" (click)="redirectToEditScreen(item)"></i></a></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="align-items-center marTopNot30">
        <div class="align-self-center form-group marTop30 paginationWrapper" style="margin-left: 150px;">
          <nav class="" aria-label="Page navigation example text-center">
            <div class="text-center">
              <div class="pagination row marLeft70">
                <div class="page-item marLeft540 marTop17" (click)="nextBtnClick(-1)">
                  <a href="javascript:void(0)" class="page-link left-traverse borderRadius5 button" [class.disabled]="page<=1">
                    <i class="fa fa-angle-left"></i> </a>
                </div>
                <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                    <p style="margin-top: 0px;">
                      <input type="text" (change)="submitMethod()" [(ngModel)]="page" class="w-25 borderRadius5 marTop2">
                      <br>
                      <b>Page</b>
                    </p>

                  </a></div>
                <div class="page-item marLeftNot42 marTop17"><a class="page-link right-traverse borderRadius5 button" href="javascript:void(0)"
                    (click)="nextBtnClick(+1)"> >
                  </a></div>
                <div class="page-item marLeftNot42 marTop17"><a href="javascript:void(0)" style="height: 33px;">
                    <p style="margin-top: 0px;">
                     <input type="text" (change)="submitMethod()" class="w-25 borderRadius5 marTop2" [(ngModel)]="size">
                     <br>
                     <b>Size</b>
                    </p>
                  </a></div>
              </div>
            </div>
          </nav>
        </div>
      </div>

    </div>

  </div>
  <!-- <app-footer></app-footer> -->

</div>
